import diff from "microdiff";
export function isDifferentObject(a, b) {
    return diff(a, b).length > 0;
}
//# sourceMappingURL=isDifferentObject.js.map